import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { useCallback, useRef, useState } from 'react';
import { mapErrorToApiError } from '../api-error';
export var useStreamingMutation = function useStreamingMutation(_ref) {
  var mutationFn = _ref.mutationFn,
    onChunkReceived = _ref.onChunkReceived,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError;
  var mutationFnRef = useRef(mutationFn);
  mutationFnRef.current = mutationFn;
  var onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;
  var onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  var onChunkReceivedRef = useRef(onChunkReceived);
  onChunkReceivedRef.current = onChunkReceived;
  var isAbortedRef = useRef(false);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMutating = _useState4[0],
    setIsMutating = _useState4[1];
  var mutate = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var _onSuccessRef$current, generator, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, _onChunkReceivedRef$c, _onErrorRef$current, apiError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsMutating(true);
            _context.prev = 1;
            _context.next = 4;
            return mutationFnRef.current(payload);
          case 4:
            generator = _context.sent;
            if (!isAbortedRef.current) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 9;
            _iterator = _asyncIterator(generator);
          case 11:
            _context.next = 13;
            return _iterator.next();
          case 13:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 21;
              break;
            }
            chunk = _step.value;
            if (!isAbortedRef.current) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return");
          case 17:
            (_onChunkReceivedRef$c = onChunkReceivedRef.current) === null || _onChunkReceivedRef$c === void 0 || _onChunkReceivedRef$c.call(onChunkReceivedRef, chunk);
          case 18:
            _iteratorAbruptCompletion = false;
            _context.next = 11;
            break;
          case 21:
            _context.next = 27;
            break;
          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](9);
            _didIteratorError = true;
            _iteratorError = _context.t0;
          case 27:
            _context.prev = 27;
            _context.prev = 28;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 32;
              break;
            }
            _context.next = 32;
            return _iterator.return();
          case 32:
            _context.prev = 32;
            if (!_didIteratorError) {
              _context.next = 35;
              break;
            }
            throw _iteratorError;
          case 35:
            return _context.finish(32);
          case 36:
            return _context.finish(27);
          case 37:
            (_onSuccessRef$current = onSuccessRef.current) === null || _onSuccessRef$current === void 0 || _onSuccessRef$current.call(onSuccessRef);
            _context.next = 45;
            break;
          case 40:
            _context.prev = 40;
            _context.t1 = _context["catch"](1);
            apiError = mapErrorToApiError(_context.t1);
            setError(apiError);
            (_onErrorRef$current = onErrorRef.current) === null || _onErrorRef$current === void 0 || _onErrorRef$current.call(onErrorRef, apiError);
          case 45:
            _context.prev = 45;
            isAbortedRef.current = false;
            setIsMutating(false);
            return _context.finish(45);
          case 49:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 40, 45, 49], [9, 23, 27, 37], [28,, 32, 36]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var abortStreaming = useCallback(function () {
    isAbortedRef.current = true;
    setIsMutating(false);
  }, []);
  return {
    error: error,
    isMutating: isMutating,
    mutate: mutate,
    abortStreaming: abortStreaming
  };
};